import { NAWSurvey } from '../../../../types/NAW/Survey'

export enum SortProp {
  name = 'name',
  lastInteraction = 'lastInteraction',
  furthestStep = 'furthestStep',
}

export enum SortDirection {
  asc = 'asc',
  desc = 'desc',
}

const sortingMechanism = (sortProp: SortProp, sortDirection: SortDirection, data: NAWSurvey[], t: any) => {
  if (sortProp === SortProp.name) {
    return data.sort((a, b) => {
      if (sortDirection === SortDirection.asc) {
        return a.name.localeCompare(b.name)
      } else {
        return b.name.localeCompare(a.name)
      }
    })
  } else if (sortProp === SortProp.lastInteraction) {
    const noLastInteractions = data.filter((item) => !item.furthestStep)
    const lastInteractions = data
      .filter((item) => !!item.furthestStep)
      .sort((a, b) => {
        const aDate = new Date(a.updatedOn).getTime()
        const bDate = new Date(b.updatedOn).getTime()
        if (sortDirection === SortDirection.asc) {
          return aDate - bDate
        } else {
          return bDate - aDate
        }
      })
    return lastInteractions.concat(noLastInteractions)
  } else if (sortProp === SortProp.furthestStep) {
    const noLastInteractions = data.filter((item) => !item.furthestStep)
    const lastInteractions = data
      .filter((item) => !!item.furthestStep)
      .sort((a, b) => {
        const steps = Object.keys(t.naw.survey.list.furthestStep)
        const aIndex = a.furthestStep ? steps.indexOf(a.furthestStep) : 10
        const bIndex = b.furthestStep ? steps.indexOf(b.furthestStep) : 10

        if (sortDirection === SortDirection.asc) {
          return aIndex - bIndex
        } else {
          return bIndex - aIndex
        }
      })
    return lastInteractions.concat(noLastInteractions)
  }
  return data
}

export default sortingMechanism
